/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button, Table, Input } from "@nordcloud/gnui";
import FlexContainer from "~/components/Styled/FlexContainer";
import { Prerequisite } from "~/models/prerequisite";

type InputPrerequisitesProps = {
  list: Prerequisite[];
  setList: React.Dispatch<React.SetStateAction<Prerequisite[]>>;
  item: Prerequisite;
};

function InputPrerequisites({ item, list, setList }: InputPrerequisitesProps) {
  return (
    <Table.tr>
      <Table.td>
        <FlexContainer>
          <Input
            type="text"
            defaultValue={item.text}
            placeholder="Prerequisite"
            onChange={(e) => {
              const { value } = e.target;
              setList((prevState: Prerequisite[]) =>
                prevState.map((prevItem: Prerequisite) => {
                  if (prevItem.id === item.id) {
                    return {
                      id: prevItem?.id,
                      text: value,
                    };
                  }

                  return prevItem;
                })
              );
            }}
          />
          <Button
            icon="minus"
            type="button"
            disabled={list && list?.length === 0}
            css={{ marginLeft: "0.5rem" }}
            severity="low"
            onClick={() => {
              const filtered = list.filter(
                (i: Prerequisite) => i.id !== item.id
              );
              setList(filtered);
            }}
          />
        </FlexContainer>
      </Table.td>
    </Table.tr>
  );
}

export { InputPrerequisites };
